import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Snackbar, Alert } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Nextstep, setQuesCountIndex, setQuesTopicName } from './features/counterSlice';
import { AnswerResult, NoanswerResult } from './features/resultSlice';
import ReactPlayer from 'react-player';

function WriteTest() {
    const apiData = useSelector((state) => state.questionResult.apiData);
    const [data, setdata] = useState(apiData.data);
    const [playing, setPlaying] = useState(false); // Audio play state
    const [currentIndex, setCurrentIndex] = useState(0);
    const [answers, setAnswers] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const [playingAudio, setPlayingAudio] = useState(null); // Track the currently playing audio instance
    const TOTAL_LISTEN = apiData?.data?.write_Que?.Total || 0;
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const [writeQueData, setWriteQueData] = useState([]);

    const pagestep = useSelector((state) => state.counter.value);
    const dispatch = useDispatch();


    if (!data || !data.write_Que || TOTAL_LISTEN === 0) {
        return (
            <Box sx={{ margin: 'auto', p: 2, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ color: 'red' }}>
                    No question found
                </Typography>
            </Box>
        );
    }

    const currentQuestion = data.write_Que[currentIndex];
    const Qcategory = currentQuestion.category || 'Radio';
    const Answer = currentQuestion.Answer || '0';
    const qtype = currentQuestion.qtype || '0';

    const handleNext = () => {
        // if (selectedOption == null) {
        //     setSnackbarMessage('Please enter your answer before proceeding!');
        //     setOpenSnackbar(true);
        //     return;
        // }
        // ======================== local storage start ======================== 
        const formatData = {
            Quetion: currentQuestion?.Quetion || "",
            id: currentQuestion?.id,
            selectedOption: selectedOption?.trim() || "",
            answer: Answer,
        }
        const updatedData = [...writeQueData, formatData];
        setWriteQueData(updatedData);
        localStorage.setItem("Write_Que", JSON.stringify(updatedData));
        // ======================== local storage end ======================== 

        const currentAnswer = answers[currentIndex];

        // Check if user typed something
        // if (!currentAnswer || currentAnswer.trim() === '') {
        //     setSnackbarMessage('Please enter your answer before proceeding!');
        //     setOpenSnackbar(true);
        //     return; // Stop moving to next question
        // }

        // Reset selected option for the next question
        setSelectedOption(null);

        setCurrentIndex((prevIndex) => {
            const newIndex = prevIndex < TOTAL_LISTEN - 1 ? prevIndex + 1 : prevIndex;
            if (prevIndex === TOTAL_LISTEN - 1) {
                dispatch(Nextstep());
            }
            dispatch(setQuesCountIndex(newIndex));
            return newIndex;
        });
    };

    const handleSpeak = (audioFileName) => {
        if (playingAudio) {
            playingAudio.pause();
            if (playingAudio.src === audioFileName) {
                setPlayingAudio(null);
                return;
            }
        }
        const audio = new Audio(audioFileName);
        audio.play();
        setPlayingAudio(audio);
        audio.onended = () => setPlayingAudio(null);
    };

    const handleKeyUp = (e, index) => {
        const value = e.target.value;
        setAnswers({ ...answers, [index]: value });
        setSelectedOption(value);
        // Example notification: empty answer
        if (!value) {
            setSnackbarMessage('Answer cannot be empty!');
            setOpenSnackbar(true);
        }
    };

    const handleSubmit = () => {
        alert("Your answers have been submitted!");
    };


    return (
        <Box sx={{ margin: 'auto', textAlign: 'center', }}>
            {/* Question Section */}
            <Box sx={{ gap: 1, padding: 1, marginTop: 7, marginBottom: 2 }}>
                <Typography
                    variant="body1"
                    sx={{ fontSize: '1.1rem', marginBottom: 1, textAlign: 'left' }}
                >
                    {currentQuestion.description}
                </Typography>
            </Box>

            {qtype === 'AudioQuestions' && (
                <Box>
                    <Box
                        display="flex"
                        alignItems="center"
                        sx={{
                            gap: 1,
                            padding: 2,
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            boxShadow: 3,
                        }}
                    >
                        <ReactPlayer
                            src={currentQuestion.Audio_file}
                            playing={playing}
                            controls
                            height="50px"
                            width="100%"
                            onPlay={() => setPlaying(true)}
                            onPause={() => setPlaying(false)}
                            onEnded={() => setPlaying(false)}
                            style={{ backgroundColor: "#FFF" }}
                        />
                    </Box>

                    <Box
                        display="flex"
                        alignItems="center"
                        sx={{
                            gap: 1,
                            padding: 2,
                            mt: 1,
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            boxShadow: 3,
                        }}
                    >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            placeholder="Type your answer..."
                            multiline
                            rows={10}
                            value={answers[currentIndex] || ""}
                            onChange={(e) => {
                                setAnswers({ ...answers, [currentIndex]: e.target.value });
                                setSelectedOption(e.target.value);
                            }}
                            onKeyUp={(e) => handleKeyUp(e, currentIndex)}
                        />
                    </Box>
                </Box>
            )}

            {qtype === 'ImageQuestions' && (
                <Box>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ gap: 1, padding: 2 }}
                    >
                        <img
                            src={currentQuestion.Audio_file}
                            alt="Question related"
                            style={{
                                maxWidth: '250px',
                                width: '100%',
                                height: 'auto',
                                display: 'block',
                            }}
                        />
                    </Box>

                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Type your answer..."
                        rows={10}
                        value={answers[currentIndex] || ""}
                        onChange={(e) => {
                            setAnswers({ ...answers, [currentIndex]: e.target.value });
                            setSelectedOption(e.target.value);
                        }}
                        onKeyUp={(e) => handleKeyUp(e, currentIndex)}
                        sx={{
                            // maxWidth: '250px',
                            marginTop: "4px",
                            backgroundColor: "#fff",
                        }}
                    />
                </Box>
            )}

            <Button onClick={handleNext} sx={{ padding: '10px 40px' }}>
                <img src="/images/Picture7.png" alt="Next" style={{ width: '150px', height: 'auto' }} />
            </Button>

            {/* Snackbar Notification */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity="warning" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
}

export default WriteTest;
